import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";

import App from "@/shared/components/photo_gallery/components/app";
import store from "@/shared/components/photo_gallery/store/index";
import { initialize } from "@/shared/components/photo_gallery/actions/index";

export default class PhotoGallery extends React.Component {
  constructor(props) {
    super(props);

    // store を初期化
    store.dispatch(
      initialize(
        store,
        props.photos,
        props.categories,
        props.categoryId,
        props.accentColor,
      ),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

// 受け取るパラメータ
PhotoGallery.propTypes = {
  photos: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  categoryId: PropTypes.number,
  accentColor: PropTypes.string,
};

// 初期値
PhotoGallery.defaultProps = {
  photos: [],
  categories: [],
  categoryId: null,
  accentColor: "",
};
